import React, { ReactNode } from 'react';
import { UseFormRegisterReturn, UseFormSetValue } from 'react-hook-form';
import { errorTextType } from '../../models/types';
export enum SelectThemes {
  TRANSPARENT = 'transparent',
  BACKGROUND = 'background',
  FROM_TABLE = 'from-table',
  HTML_SELECT = 'html-select',
  STATISTICS_SELECT = 'statistics-select',
}
export type OptionValue = null | undefined | number | string;
export interface RecursiveSelect {
  titleFieldName: string;
  idFieldName?: string;
  data?: any;
}
export interface Option {
  element?: ReactNode;
  title?: string | null;
  titleClassName?: string;
  tooltipTitle?: string;
  value: OptionValue;
  searchValue?: string;
  isControllerHidden?: boolean;
  key?: string | number;
  controllerOption?: {
    element?: ReactNode;
    title?: string | null;
  };
  multiselectPointColor?: string;
}
export type PropsValue = OptionValue | OptionValue[];
export interface SelectProps {
  className?: string;
  options?: Option[];
  hasSearch?: boolean;
  disablePortal?: boolean;
  container?: HTMLElement | null;
  recursiveSelect?: RecursiveSelect;
  propsValue?: PropsValue;
  defaultValue?: OptionValue;
  noValueText?: string;
  disabled?: boolean;
  onSearch?: (value: string) => void;
  controllerClassName?: string;
  isMultiSelect?: boolean;
  theme?: SelectThemes;
  register?: UseFormRegisterReturn;
  setValueInForm?: UseFormSetValue<any>;
  onChange?: (value: any, event?: React.MouseEvent) => void;
  fetchNextPage?: () => void;
  hasMore?: boolean;
  disableSearchLimit?: boolean;

  errorText?: errorTextType;
  isOptionsCenter?: boolean;
  withOptionsDivider?: boolean;
  dropdownClassName?: string;
  onOpen?: () => void;
  dataQaSelector?: string;
  iconClassname?: string;
  approveNullValue?: boolean;
}
